<template>
  <breadCrumbs title="Chart" main="Widgets" title1="Chart" />

  <div class="container-fluid">

    <topPage />

    <div class="row">

      <marketingPage />
      <earningPage />
      <skillPage />
    </div>

    <div class="row">
      <livePage />
      <monthlyPage />



    </div>
    <div class="row">
      <browseruserPage />

    </div>
    <financeorderPage />

  </div>
</template>
<script>
import topPage from '../charts/topPage.vue'
import marketingPage from '../charts/marketingPage.vue'
import earningPage from '../charts/earningPage.vue'
import skillPage from '../charts/skillPage.vue'
import livePage from '../charts/liveturnoverPage.vue'
import monthlyPage from '../charts/monthlyPage.vue'
import browseruserPage from '../charts/browseruserPage.vue'
import financeorderPage from '../charts/financeorderPage.vue'
export default {
  name: 'indexChart',
  components:
  {
    topPage,
    marketingPage,
    earningPage, browseruserPage,
    skillPage, livePage, monthlyPage, financeorderPage
  }

}

</script>